"use client";
import dynamic from "next/dynamic";
import type { GoogleMapByLatLngProps } from "./GoogleMap";

const GoogleMap = dynamic(() => import("./GoogleMap"), { ssr: false });

export const GoogleMapDynamicWrapper = ({
  ...props
}: GoogleMapByLatLngProps<unknown>) => {
  return <GoogleMap {...props} />;
};
